export default __webpack_public_path__ + "static/media/9h.57625bf3.png";